export default __webpack_public_path__ + "static/media/6.591d4ba9.png";